import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleRight,faCheckCircle, faCogs, faExclamationTriangle, faMapMarkerAlt, faQuestionCircle, faSyncAlt, faTachometerAlt, faSort } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { createMetaManager } from 'vue-meta'
import Environment from '@/utils/environment'
import App from './App.vue'
import * as Sentry from '@sentry/vue'

import { languages } from './i18n'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'

const app = createApp(App)

// app.config.productionTip = false

library.add(faAngleDown, faAngleRight, faCheckCircle, faCogs, faExclamationTriangle, faMapMarkerAlt, faQuestionCircle, faSyncAlt, faTachometerAlt, faSort)

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(VueAxios, axios)

// Retrieve environment variables from docker
app.config.globalProperties.$baseUrl = Environment.value('apiUrl')

const locale = navigator.language
const messages = Object.assign(languages)
export const i18n = createI18n({
  allowComposition: true,
  locale: locale, // set locale
  fallbackLocale: 'fr',
  messages // set locale messages
})

Sentry.init({
  app,
  release: __APP_VERSION__,
  environment: import.meta.env.MODE,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    })
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(createMetaManager(false, {meta: {tag: 'meta', nameless: true}}))

app.use(i18n)
app.mount('#app')
